import React from 'react';

const data = [
  {
    icon: 'mdi-monitor',
    title: 'Your business branded borrower portal',
    description:
      'Your business branded borrower dashboard allows your leads to communicate with you, send unlimited loan application documents and bank statements securely without getting charged per client, and builds your business brand',
  },
  {
    icon: 'mdi-file-document-outline',
    title: 'Effortless document and electronic bank statement collection',
    description:
      'Create your custom document templates with automated reminders and TFN redaction. Collect bank statements electronically with the ability to customise time period for each lead and categorise income/expenses',
  },
  {
    icon: 'mdi-calendar-sync-outline',
    title: '2-way calendar sync',
    description:
      'Organise your schedule better by giving your customers the visibility they need to book in meetings. Our 2-way sync updates your calendar in real-time regardless of time zone and where the change was made',
  },
  {
    icon: 'mdi-email-multiple-outline',
    title: 'Powerful Email Marketing Automation',
    description:
      'Powerful email marketing automation to send targeted and personalized messages, based on prospect’s interests, and improve your chances of converting enquiry into happy customer. Up to 500 contacts per user with unlimited email sending are included. Additional contacts can be purchased from within the portal',
  },
  {
    icon: 'mdi-briefcase-account-outline',
    title: 'Smarter Lead Management Platform',
    description:
      'Smarter lead management platform with automated follow-up reminders and tasks assignments to your team members so you have more time to sell',
  },
  {
    icon: 'mdi-file-document-edit-outline',
    title: 'Access additional revenue or funds for growth',
    description: 'Get additional revenue through our partners or access quick funding to grow your business',
  },
  {
    icon: 'mdi-transit-connection-horizontal',
    title: 'Complete Aggregator Integration',
    description:
      "Effi automatically syncs 2-way with Salestrekker so you don't have to enter information and documents again",
  },
  {
    icon: 'mdi-lock-check-outline',
    title: 'Secure and compliant platform',
    description:
      'We employ only secure HTTPS connections, where all information is encrypted, with daily backups. For optimized performance and compliance, your data is hosted in Sydney, Australia',
  },
  {
    icon: 'mdi-arrow-expand-horizontal',
    title: 'Two-way portal view to ensure you and your customers are aligned',
    description:
      'Impersonate borrower dashboard anytime and help your borrowers complete the information by adding information at your end',
  },
  {
    icon: 'mdi-contacts-outline',
    title: 'Purchase appointments from high traffic comparison websites',
    description:
      'Showcase your profile on high traffic websites for the whole world to see and receive enquiries from borrowers who select you only to discuss their loan requirements',
  },
  {
    icon: 'mdi-message-alert-outline',
    title: 'Send SMS from your phone or our smart Bot',
    description:
      'Sync your phone to send SMS from your mobile number or use our AI-powered SMSbot to re-engage lost leads or nuture leads to book an appointment with you',
  },
  {
    icon: 'mdi-draw',
    title: 'Reporting and e-signature (Full version only)',
    description:
      'View performance of all brokers within your business in real-time with actionable insights to realise the full potential of your brokers',
  },
];

const Features = () => {
  return (
    <div className="feature-wrapper">
      {data.map(featureData => (
        <FeatureItem
          icon={featureData.icon}
          title={featureData.title}
          description={featureData.description}
          key={featureData.id}
        />
      ))}
    </div>
  );
};

export default Features;

const FeatureItem = props => {
  return (
    <div className="feature-item">
      <i className={'mdi' + ' ' + props.icon}></i>
      <p>{props.title}</p>
      <span>{props.description}</span>
    </div>
  );
};
